<template>
    <f-fullscreen-modal ref="bottomSheet" @hide="reset()">
        <f-app-screen>
            <f-app-body class="flex flex-col flex-nowrap">
                <div class="safe-area-top"></div>
                <div class="px-6 tall:py-6 py-3 flex flex-col items-center">
                    <button
                            @click="$refs.bottomSheet.close()"
                            class="self-end mb-3 rounded-full p-2 w-8 h-8 flex items-center justify-center bg-slate-blue-850"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                            <path d="M1.04932 9.18207C0.738281 9.49311 0.731934 10.0454 1.05566 10.3691C1.38574 10.6928 1.93799 10.6865 2.24268 10.3818L6.00049 6.62397L9.75195 10.3754C10.0693 10.6928 10.6152 10.6928 10.939 10.3691C11.2627 10.039 11.2627 9.49946 10.9453 9.18207L7.19385 5.43061L10.9453 1.6728C11.2627 1.35541 11.269 0.809515 10.939 0.485785C10.6152 0.162054 10.0693 0.162054 9.75195 0.479437L6.00049 4.2309L2.24268 0.479437C1.93799 0.168402 1.37939 0.155707 1.05566 0.485785C0.731934 0.809515 0.738281 1.36811 1.04932 1.6728L4.80078 5.43061L1.04932 9.18207Z" fill="white"/>
                        </svg>
                    </button>

                    <h1 class="mb-8">{{$t('upgradeSheet.title.chooseYourPlan')}}</h1>

                    <div class="bg-slate-blue-850 rounded-lg p-4 flex flex-col flex-nowrap gap-3 w-full">
                        <div class="flex flex-row items-center justify-between">
                            <div class="flex flex-row items-center gap-2">
                                <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="12" r="10" fill="#6E67BC"/>
                                    <path d="M10.7441 12.502H8.20801L8.19434 11.251H10.4092C10.7829 11.251 11.0996 11.1963 11.3594 11.0869C11.6237 10.973 11.8242 10.8112 11.9609 10.6016C12.0977 10.3874 12.166 10.1299 12.166 9.8291C12.166 9.49642 12.1022 9.22526 11.9746 9.01562C11.847 8.80599 11.651 8.65332 11.3867 8.55762C11.127 8.46191 10.7943 8.41406 10.3887 8.41406H8.72754V17H7.01172V7.04688H10.3887C10.9355 7.04688 11.4232 7.09928 11.8516 7.2041C12.2845 7.30892 12.6514 7.47298 12.9521 7.69629C13.2575 7.91504 13.4876 8.19303 13.6426 8.53027C13.8021 8.86751 13.8818 9.26855 13.8818 9.7334C13.8818 10.1436 13.7839 10.5195 13.5879 10.8613C13.3919 11.1986 13.1025 11.4743 12.7197 11.6885C12.3369 11.9027 11.8607 12.0303 11.291 12.0713L10.7441 12.502ZM10.6689 17H7.66797L8.44043 15.6396H10.6689C11.0563 15.6396 11.3799 15.5758 11.6396 15.4482C11.8994 15.3161 12.0931 15.1361 12.2207 14.9082C12.3529 14.6758 12.4189 14.4046 12.4189 14.0947C12.4189 13.7712 12.362 13.4909 12.248 13.2539C12.1341 13.0124 11.9541 12.8278 11.708 12.7002C11.4619 12.568 11.1406 12.502 10.7441 12.502H8.81641L8.83008 11.251H11.3389L11.7285 11.7227C12.2754 11.7409 12.7243 11.8617 13.0752 12.085C13.4307 12.3083 13.695 12.5977 13.8682 12.9531C14.0413 13.3086 14.1279 13.6914 14.1279 14.1016C14.1279 14.735 13.9889 15.266 13.7109 15.6943C13.4375 16.1227 13.0433 16.4486 12.5283 16.6719C12.0133 16.8906 11.3936 17 10.6689 17Z" fill="white"/>
                                </svg>

                                <div class="text-sm text-slate-blue-200 font-medium">{{$t('upgradeSheet.testimonial.author')}}</div>
                            </div>

                            <div class="flex flex-row flex-nowrap">
                                <img src="@/assets/icons/star.svg" alt="Star" v-for="i in 5" :key="i"/>
                            </div>
                        </div>

                        <div>
                            {{$t('upgradeSheet.testimonial.text')}}
                        </div>

                        <div class="text-sm text-slate-blue-200 font-medium">{{$t('upgradeSheet.testimonial.date')}}</div>
                    </div>
                </div>

<!--                <div class="text-center px-6 tall:py-6 py-3">
                    <h1 class="mb-3 xs:mb-3 tall:text-3xl text-xl">{{ $t('upgrade.pro.title') }}</h1>
                    <p class="text-sm text-slate-blue-100">{{ $t('upgrade.pro.subtitle') }}</p>

                    <ul class="text-left text-sm mt-6">
                        <li>{{$t("upgrade.benefits.school")}}</li>
                        <li>{{$t("upgrade.benefits.trend.predictor", { count: gameProCount })}}</li>
                        <li>{{$t("upgrade.benefits.quiz", { count: quizProCount })}}</li>
                        <li>{{$t("upgrade.benefits.ads")}}</li>
                    </ul>
                </div>-->


                <div class="safe-area-bottom mt-auto">
                    <package-select
                            class="px-6 pb-3 xs:pb-6"
                            ref="packageSelectRef"
                            @upgrade="onUpgrade"
                    />
                </div>
            </f-app-body>
        </f-app-screen>
    </f-fullscreen-modal>
</template>

<script>
import Analytics, { SCREEN_UPGRADE } from '/src/services/Analytics'
import { Network } from '@capacitor/network'
import AppService from '@/services/AppService'
import PackageSelect from '@/components/subscriptions/PackageSelect.vue'


export default {
  name: 'UpgradeSheet',
  components: {
    PackageSelect
  },
  data () {
    return {
      // schoolTopics: {
      //   pro: 0,
      //   free: 0
      // },
      gameProCount: 0,
      quizProCount: 0,

      resolve: null,
      upgrading: false,
      offline: false,
      loading: false
    }
  },
  methods: {
    reset () {
      this.$refs.packageSelectRef?.reset()
    },
    close() {
      return this.$refs.bottomSheet.close()
    },
    async onUpgrade (product) {
      await this.$refs.bottomSheet.close()

      if (this.resolve) {
        this.resolve()
      }
    },
    async open () {
      // Start showing loading to prevent flashing of "no-packagees" message
      this.loading = true

      // this.refreshCount()

      await this.$refs.bottomSheet.open()

      Analytics.setScreenName(SCREEN_UPGRADE)
      AppService.registerAppEvent('upgrade_view_open')

      const { connected } = await Network.getStatus()

      if (connected) {
        await this.$refs.packageSelectRef.refreshPackages()
      }

      this.loading = false

      return new Promise((resolve) => {
        this.offline = !connected
        this.resolve = resolve
      })
    }
  }
}
</script>
